import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';

// Page Imports
import Home from '../pages/Home';
import Services from '../pages/Services';
import Gallery from '../pages/Gallery'; // ✅ Added Gallery Import
import Pricing from '../pages/Pricing';
import Contact from '../pages/Contact';

/**
 * Helper Component: ScrollToTop
 * Fixes the common React issue where navigation doesn't reset scroll position.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

/**
 * AppRoutes Component
 * Updated with Gallery route and Scroll fix.
 */
const AppRoutes = ({ lang, toggleLang }) => {
  return (
    <MainLayout lang={lang} toggleLang={toggleLang}>
      {/* Ensures every page starts at the top */}
      <ScrollToTop />

      <Routes>
        {/* Main Pages */}
        <Route path='/' element={<Home lang={lang} />} />
        <Route path='/services' element={<Services lang={lang} />} />

        {/* ✅ Added Gallery Route */}
        <Route path='/gallery' element={<Gallery lang={lang} />} />

        <Route path='/pricing' element={<Pricing lang={lang} />} />
        <Route path='/contact' element={<Contact lang={lang} />} />

        {/* SEO & Best Practices Redirect */}
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
    </MainLayout>
  );
};

export default AppRoutes;
